var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUspRabbit = function SvgUspRabbit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 72 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 28,
    r: 22,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 62C46.8373 62 52 54.8373 52 46C51.9818 44.5985 51.7764 43.2057 51.3893 41.8587C54.3049 41.5282 56.9971 40.1373 58.9537 37.9506C60.9102 35.7639 61.9945 32.9342 62 30C62 20 56 18 42 10C28 2 22 -5.96046e-08 20 4C18 8 22 12 30 16L41.3733 21.6853C39.211 23.9131 38.0011 26.8954 38 30C38 30.0693 38.0187 30.1333 38.0213 30.2027C37.3526 30.0917 36.6774 30.0241 36 30H18C13.7565 30 9.68687 31.6857 6.68629 34.6863C3.68571 37.6869 2 41.7565 2 46C2 50.2435 3.68571 54.3131 6.68629 57.3137C9.68687 60.3143 13.7565 62 18 62H28",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 46C22 46 26 54 22 62",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 62H50",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28C53.2652 28 53.5196 28.1054 53.7071 28.2929C53.8946 28.4804 54 28.7348 54 29",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29C52 28.7348 52.1054 28.4804 52.2929 28.2929C52.4804 28.1054 52.7348 28 53 28",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30C52.7348 30 52.4804 29.8946 52.2929 29.7071C52.1054 29.5196 52 29.2652 52 29",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54 29C54 29.2652 53.8946 29.5196 53.7071 29.7071C53.5196 29.8946 53.2652 30 53 30",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUspRabbit;